import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function DesktopServiceRequestForm() {
  return <ServiceRequestForm serviceType="DesktopService" title="Desktop" />;
}

